import cx from 'classnames';
import { PropsWithChildren } from 'react';
import Box, { BoxStyleProps } from '../../Box';

import styles from './BottomSheetBody.module.css';

interface BottomSheetBodyProps extends BoxStyleProps {
  className?: string;
}

export default function BottomSheetBody({
  className,
  children,
  ...otherProps
}: PropsWithChildren<BottomSheetBodyProps>): JSX.Element {
  return <Box className={cx(styles['base'], className)} {...otherProps}>{children}</Box>;
}
